const dom = {};
const state = {
    type: "",
    page: 1,
    filters: [],
    taggedSelection: null,
    seo: {
        meta_title: '',
        meta_description: '',
        h1: ''
    }
};
const apiUrlPrefix = `/api/property`;
import Utils from "../helpers/utils";

const init = (_) => {
    cacheDOM();
    state.type = dom.root.dataset.catalog;
    state.page = +dom.root.dataset.catalogCurrentPage ?? 1;
    state.seo.meta_title = dom.root.dataset.catalogRootTitle;
    state.seo.meta_description = dom.root.dataset.catalogRootDescription;
    state.seo.h1 = dom.root.dataset.catalogRootH1;
    bindEvents();
};

const cacheDOM = (_) => {
    dom.root = document.querySelector("[data-catalog]");
    dom.filters = dom.root.querySelector("[data-catalog-filters]");
    dom.counts = dom.root.querySelector("[data-catalog-counts]");
    dom.list = dom.root.querySelector("[data-catalog-list]");
    dom.pagination = dom.root.querySelector("[data-catalog-pagination]");
    dom.reset = dom.root.querySelector("[data-catalog-reset]");
    dom.loader = dom.root.querySelector("[data-catalog-loader]");
    dom.breadcrumbs = dom.root.querySelector("[data-catalog-breadcrumbs]")
};

const bindEvents = (_) => {
    dom.filters.addEventListener(
        "input",
        Utils.debounce(handleFiltersChange, 500)
    );
    dom.filters.addEventListener("click", handleTagClick);
    dom.reset.addEventListener("click", handleResetClick);
    dom.pagination.addEventListener("click", handlePaginationClick);
};

const handleFiltersChange = async (_) => {
    dom.filters
        .querySelectorAll("[data-tag-params]")
        .forEach((btn) => btn.classList.remove("is-active"));
    getFiltersValues();
    state.page = 1;
    showItems(true);
};

const showItems = async (clearList) => {
    setIsLoading(true);
    const data = await getItems();
    state.taggedSelection = data.taggedSelection;
    render({ data, clearList });
    replaceUrl();
    setIsLoading(false);
};
const getFiltersValues = (_) => {
    state.filters = [
        ...dom.filters.querySelectorAll(`input:checked, input[type=number], [name="price[min]"], [name="price[max]"], [name="np_price[min]"], [name="np_price[max]"]`),
    ]
        .map((i) => [i.name, i.mask ? i.mask.unmaskedValue : i.value])
        .filter(([name, value]) => value);


    const selectValues = [
        ...dom.filters.querySelectorAll("select[data-dropdown-value]"),
    ]
        .map((select) => {
            const selectedOptions = select.querySelectorAll('option[selected]');
            return selectedOptions.length
                ? [...selectedOptions].map((option) => option.value ? [
                    select.name,
                    option.value,
                ] : null)
                : null
        }

        )
        .filter((item) => item);
    state.filters.push(...selectValues.flat().filter((item) => item));

};

const setIsLoading = (isLoading) => {
    dom.loader.classList.toggle("is-active", isLoading);
};

const getItems = async (_) => {
    const params = getFiltersParams();
    const req = await fetch(
        `${apiUrlPrefix}/${state.type}?${params}&page=${state.page}`
    );
    const res = await req.json();
    return res;
};

const getFiltersParams = (_) => {
    return state.filters
        .sort()
        .map(([name, value]) => `${name}=${value}`)
        .join("&");
};

const replaceUrl = (_) => {
    const url = state.taggedSelection
        ? `/catalog/search/${state.type}/${state.taggedSelection.slug}/`
        : `/catalog/search/${state.type}/?${getFiltersParams()}${state.page > 1 ? `&page=${state.page}` : ""
        }`;
    history.replaceState(
        null,
        null,
        url
    );
};

const handleResetClick = (evt) => {
    resetFilters();
    handleFiltersChange();
};
const resetFilters = (_) => {
    dom.filters.querySelectorAll("input:checked").forEach((input) => {
        input.checked = false;
    });
    dom.filters.querySelectorAll('input[type=number], [name="price[min]"], [name="price[max]"], [name="np_price[min]"], [name="np_price[max]"]').forEach((input) => {
        input.value = "";
        if (input.mask) {
            input.mask.unmaskedValue = '';
        }
        input.classList.remove('is-filled');
    });
    dom.filters
        .querySelectorAll("[data-dropdown]")
        .forEach((el) => el.dropdown.reset(false));
};

const render = ({ data, clearList }) => {
    if (clearList) {
        dom.list.innerHTML = "";
    }
    dom.list.insertAdjacentHTML("beforeend", data.items);
    dom.pagination.innerHTML = data.pagination;
    dom.counts.innerHTML = data.countsString;
    document.dispatchEvent(new CustomEvent("ll::needUpdate"));
    document.title = state?.taggedSelection?.meta_title || state.seo.meta_title;
    document.querySelector('meta[name="description"]').content = state?.taggedSelection?.meta_description || state.seo.meta_description;
    document.querySelector('h1').innerText = state?.taggedSelection?.h1 || state.seo.h1;
    dom.filters.querySelectorAll('[data-tag-id]').forEach(tag => {
        tag.classList.toggle('is-active', tag.dataset.tagId === String(state?.taggedSelection?.id))
    })
    if (data.breadcrumbs) {
        dom.breadcrumbs.innerHTML = data.breadcrumbs
    }

};

const handlePaginationClick = (evt) => {
    const loadMoreBtn = evt.target.closest("[data-catalog-show-more]");
    const pageLink = evt.target.closest("[data-pagination-link]");
    if (loadMoreBtn) loadMore();
    if (pageLink) {
        evt.preventDefault();
        loadPage(+pageLink.dataset.paginationLink);
    }
};

const loadMore = async (_) => {
    state.page++;
    showItems(false);
};

const loadPage = async (page) => {
    state.page = page;
    showItems(true);
    dom.filters.scrollIntoView({ behavior: "smooth" });
};

const handleTagClick = (evt) => {
    const btn = evt.target.closest("[data-tag-params]");
    if (!btn) return;
    evt.preventDefault();
    dom.filters
        .querySelectorAll("[data-tag-params]")
        .forEach((btn) => btn.classList.remove("is-active"));
    btn.classList.add("is-active");
    resetFilters();
    const params = JSON.parse(btn.dataset.tagParams);
    const tags = params.filter((param) => +param.type === 1);
    const filters = params.filter((param) => +param.type === 0);
    state.filters = [
        ...filters
            .map((i) => [i.filter_id, i.filter_value])
            .filter(([name, value]) => value),

        ...tags
            .map((i) => ["tags[]", i.tag_name])
            .filter(([name, value]) => value),
    ];
    const filtersObj = Object.fromEntries(state.filters);

    dom.filters.querySelectorAll('[type="checkbox"]').forEach(checkbox => {
        if (filtersObj[checkbox.name]) {
            checkbox.checked = filtersObj[checkbox.name].includes(checkbox.value)
        }
    });
    dom.filters.querySelectorAll('[type="radio"]').forEach(checkbox => {
        if (filtersObj[checkbox.name]) {
            checkbox.checked = filtersObj[checkbox.name][0] === checkbox.value;
        }
    });
    dom.filters.querySelectorAll('[data-dropdown]').forEach(dropdown => {
        if (filtersObj[dropdown.dataset.dropdownName]) {
            dropdown.dropdown.reset(false, false);
            dropdown.dropdown.setByIds(filtersObj[dropdown.dataset.dropdownName])
        }
    })

    showItems(true);
};

export default {
    init,
};
